import * as R from 'coact/ramda'
import mergeConfig from 'coact/config/mergeConfig'
import customers from './customers.js'
import suppliers from './suppliers.js'
import pdtSeries from './pdtSeries.js'
import pdtTypes from './pdtTypes.js'
import skuColors from './skuColors.js'
import skuSizes from './skuSizes.js'
import sizeSets from './sizeSets.js'
import pricebooks from './pricebooks.js'
import prices from './prices.js'
import warehouses from './warehouses.js'
import stocks from './stocks.js'
import stockRecords from './stockRecords.js'
import receivables from './receivables.js'
import recStatements from './recStatements/index.js'
import salesOrders from './salesOrders/index.js'
import transferOrders from './transferOrders.js'
import salesReqs from './salesReqs/index.js'

const basicModels = {
  // staffers: require('./staffers'),
  customers,
  suppliers,
  pdtSeries,
  pdtTypes,
  skuColors,
  skuSizes,
  sizeSets,
  // skus: require('./skus'),
  pricebooks,
  prices,
  warehouses,
  stocks,
  stockRecords,
  receivables,
}

const { models } = R.reduce(mergeConfig, {}, [
  { models: basicModels },
  recStatements,
  salesOrders,
  transferOrders,
  salesReqs,
])

export default models
